// extracted by mini-css-extract-plugin
export default {"title":"qSymH","text":"ZVuO9"};